import api from "./axios";

// Employee personal calendar notes (date-range, title + description).
export const myCalendarNotes = (params = {}) => api.get("/my/calendar-notes", { params });
export const createCalendarNote = (payload) => api.post("/my/calendar-notes", payload);
export const updateCalendarNote = (id, payload) => api.put(`/my/calendar-notes/${id}`, payload);
export const deleteCalendarNote = (id) => api.delete(`/my/calendar-notes/${id}`);

// Admin: every employee's calendar notes overlapping a date range + manage any.
export const adminCalendarNotes = (params = {}) => api.get("/calendar-notes", { params });
export const adminCreateCalendarNote = (payload) => api.post("/calendar-notes", payload);
export const adminUpdateCalendarNote = (id, payload) => api.put(`/calendar-notes/${id}`, payload);
export const adminDeleteCalendarNote = (id) => api.delete(`/calendar-notes/${id}`);
